import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function ArrowRightIcon(props: IconProps) {
    return <Icon {...props} iconKey={"arrow_right"}/>
}
